import React from "react";
import { useTranslation } from "react-i18next";

import { CustomAlert } from "@shared/CustomAlert/CustomAlert";

import { useStyles } from "./AdvanceModeSection.style";
import { ValidationErrors } from "./AdvanceModeSection.utils";

export const NoteSection = (props: { show: boolean }) => {
    const { t } = useTranslation(["pages"]);

    if (!props.show) {
        return null;
    }

    return <CustomAlert severity="info">{t("pages:productPage.advanceModeSection.advanceModeNote")}</CustomAlert>;
};
export const ParseErrorSection = (props: { error: string | null }) => {
    const { t } = useTranslation(["pages"]);

    if (!props.error) {
        return null;
    }

    return <CustomAlert severity="error">{t("pages:productPage.advanceModeSection.advanceModeWarningInvalidJSON")}</CustomAlert>;
};
export const ErrorSection = (props: { errors: ValidationErrors[] }) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages"]);

    if (!props.errors.length) {
        return null;
    }

    return (
        <CustomAlert
            severity="error"
            title={t("pages:productPage.advanceModeSection.advanceModeWarningValidationErrors", { count: props.errors.length })}
        >
            <ul className={classes.list}>
                {props.errors.map((item) => (
                    <li key={item.path + item.message}>
                        {item.path}: {item.message}
                    </li>
                ))}
            </ul>
        </CustomAlert>
    );
};
export const WarningSection = (props: { warnings: string[] }) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages"]);

    if (!props.warnings.length) {
        return null;
    }

    return (
        <CustomAlert
            severity="warning"
            title={t("pages:productPage.advanceModeSection.advanceModeWarningUnknown", { count: props.warnings.length })}
        >
            <ul className={classes.list}>
                {props.warnings.map((item) => (
                    <li key={item}>{item}</li>
                ))}
            </ul>
        </CustomAlert>
    );
};
